import { Filter } from '@cbre/components';
import { EntityType } from './entity-enum';

export interface ISnackBar {
  message: string;
  action?: string;
  duration?: number;
}

export interface IOption {
  key?: any;
  value: string;
  field?: string; // property.address.city
  inputType?: string; // text, number, dropdown, slider, date
  type?: string; // criteria type eq, or, range
  dataType?: string;
  tooltip?: string;
  checked?: boolean;
  selected?: boolean;
  values?: any;
  code?: any;
  associations?: IOption[] | any;
  reorderPosition?: number;
  condition?: string;
  label?: string;
  allowNegativeNumbers?: boolean;
  closeIcon?: boolean;
  disabled?: boolean;
  displayName?: string;
  includeEmpty?: boolean;
  excludeEmpty?: boolean;
  excludeSelection?: boolean;
  children?: IOption[];
  multiHideAllLink?: boolean;
  group_key?: string;
  selectItemsInGroup?: boolean;
  groupOrder?: number[];
  allowedEntities?: EntityType[];
  has_data?: string;
  /**
   * Stores selected option metadata (key + displayName) for multi-select filters
   * Used to preserve displayName when selections have 0-count and are not in aggregations
   * Persisted to localStorage and saved searches
   */
  persistentSelection?: Array<{ key: string | number; displayName: string }>;
  /**
   * Catalog of available compound filters returned by the server for this filter.
   * Each entry is an additional field the search can extend to (e.g. "Legal Name", "Alias").
   * The selected subset is stored as QueryCriteria[] in the search state.
   * Typed as IOption[] | any to remain compatible with the MapFilterOption intersection
   * (same pragmatic pattern used by `associations`).
   */
  compoundFilters?: IOption[] | any;
}

/**
 * Added new type to Slowly transition to using Filter from @cbre/components, IOption should only be used as the
 * interface for dropdowns or aggregations not as Filter. Filter should be its own type and not be mixed with IOption
 */
export type IFilter = IOption & Pick<Filter, 'LabelRenderer'> & { pinned?: boolean };

export interface IOptionDropdown {
  key: string;
  value: number;
  desc?: string;
}

export interface PlainOption {
  key: number | string;
  value: string;
}
export interface DaysOpenOption {
  key: object;
  value: string;
}

export interface Comment {
  id?: number;
  message: string;
  createBy?: string;
  email?: string;
  itsMe?: boolean;
  createTs?: Date;
}

export interface ICatalog {
  key: number | string;
  value: string;
}

export enum CatalogId {
  invalid,
  US = 1,
}

export interface ITimeTrack {
  userId?: number;
  resourceId?: number;
  pageId?: number;
}

export interface ICountryList {
  countryId: number;
  countryName: string;
  languageView: ICountryLanguageList[];
}

export interface ICountryLanguageList {
  languageId: number;
  languageType: string;
  languageDesc: string;
  lobName?: string;
}

export interface Catalogs {
  catalogName?: string;
  countryName?: string;
  lobShortDesc?: string;
  desc?: string;
  edit?: boolean;
  key?: number;
  countryId?: number;
  catalogId?: number;
  lobId?: number;
}

export interface Country {
  key?: number;
  countryName?: string;
  lobs: LineOfBusiness[];
}
export interface LineOfBusiness {
  lobId?: number;
  lobName?: string;
}

export interface CustomInputConfig {
  text?: TextInputConfig;
}

export interface TextInputConfig {
  search?: { isEnabled: boolean };
  clearButton?: { isEnabled: boolean; restrictTyping?: boolean; currentValue?: string };
  options?: { isDisabled?: boolean };
}

export interface AuthorizedView {
  catalog: number;
  name: string;
  view: number;
}

export const StaticReportType = 1;

export const ReportTypes = {
  property: {
    property: StaticReportType,
    developmentPipeline: 7,
    tagOutput: 8,
  },
  availability: {
    availability: StaticReportType,
    tagOutput: 8,
  },
};

export enum AuthorizedViews {
  DevelopmentPipeline = 12,
  TagOutput = 14,
}

/**
 * Colloquial values for an active language. These values are used to select withing the list of translations what
 * value to read/write when catalog has active colloquial fields
 */
export interface ColloquialAttributes {
  /**
   * Country Code Description
   */
  country_code_desc: string;
  /**
   * Country Language Description or Variation
   */
  language_desc: string;
}
